import React, { useState, useEffect } from "react";
import Card from "./Card";
// import Pagination from '@mui/material/Pagination';
// import Footer from "../Footer/Footer";
import PaginationTwo from "../PaginationTwo/PaginationTwo";
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, addDataPosition, refreshTheAd, fetchAnchorValue, isCSR, insertAdSlot } from './../../../common/utils';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { CacheProvider } from '@emotion/react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Typography from '@mui/material/Typography';
// import Link from '@mui/material/Link';
import "./GridViewTwo.css";
import { PAGEBUILDER_URLS } from "../../Common/Constant";
import bcrypt from 'bcryptjs-react';
// import { isMobile, isDesktop } from "react-device-detect";

GridViewTwo.version = 1000;

GridViewTwo.lang = 'en';
GridViewTwo.langs = [
  'en'
];
GridViewTwo.setLang = (lang: any) => {
  GridViewTwo.lang = lang;
}

Object.defineProperty(GridViewTwo, 'name', {
  writable: true,
  value: 'GridViewTwo'
});

function NextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", right: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      <KeyboardArrowRightIcon fontSize='medium' />
    </div>
  );
}

function PrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block", background: "#585858", color: "#fff", left: "0", zIndex: "5", width: "32px", height: "32px", borderRadius: "4px" }} onClick={onClick}>
      <KeyboardArrowLeftIcon fontSize='medium' />
    </div>
  );
}

export function GridViewTwo(props: any) {
  const [cardListData, setCardListData] = useState<any>([]);
  const [currentPageData, setCurrentPageData] = useState<any>([]);
  const [paginationMetaData, setPaginationData] = useState<any>({});
  const [currentPageIndex, setCurrentPageIndex] = useState<any>(1);
  const [refreshAdPg, setRefreshAdPg] = useState<any>(1);
  let styles = require("./GridViewTwo.css");
  appendStyleSheet("GridViewTwo", styles);

  const {
    onClick,
    mobileView,
    showDate,
    showAuthor,
    cardTextColor,
    mainHeadingColor,
    //title,
    type1 = "page",
    MSID,
    showViewAll,
    viewAllUrl,
    isCarousel,
    isCircular,
    showAdSlot,
    showViewport,
    mainHeading,
    mainHeadingHref,
    anchorLinksValue
  } = props;

  var { imagesInViewport } = props;

  const setData = (val: any) => {
    if (type1 == "page") {
      const obj: pageData = { page: 1, items: val?.items };
      setCardListData([obj]);
    } else {
      setCardListData(val?.items)
    }

    setCurrentPageData(val?.items);
    setPaginationData({ count: val?.pg?.tp })
  }

  // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
  // useEffect(() => {
  //     setClientDevice({ isDesktop, isMobile });
  // }, []);

  // useEffect(() => {
  //   if (clientDevice.isDesktop && props.bodyAdScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  //   if (clientDevice.isMobile && props.bodyAdMobileScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  // }, [clientDevice.isDesktop,clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]); 

  const endpoint = getEndpoint(props);
  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [MSID, endpoint, type1, showAdSlot]);

  if (endpoint.isSSR && endpoint.SSRDataObj
    && currentPageData && Object.keys(currentPageData).length === 0 && endpoint.SSRDataObj.pg && Object.keys(endpoint.SSRDataObj.pg).length != 0
    && endpoint.SSRDataObj.pg.tr != 'null' && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length != 0) {
    setData(endpoint.SSRDataObj);
  }
  
    useEffect(() => {
      if (typeof window !== 'undefined' && window.gpEditor) {
  
          window.gpEditor.editor.on('component:selected', (component: any) => {
              if (component && component.attributes && component.attributes.type === "GridView Two") {
                  setTimeout(() => {
                      const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                      if (trait && trait.el) {
                          // Show trait element if showAdSlot is true, hide otherwise
                          trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                      }
                  }, 200);
              }
          });
  
          const selected = window.gpEditor.getSelected();
          if (selected) {
              const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
              if (trait && trait.el) {
                  // Show trait element if showAdSlot is true, hide otherwise
                  trait.el.style.display = props.showAdSlot ? 'block' : 'none';
              }
          }
      }
    }, [endpoint, props.showAdSlot, props.adSize]);

  const carouselRef = React.useRef(null);

  // let i_scrollMode = true;
  // if( props.scrollMode && props.scrollMode == props.CONSTANTS.SCROLL_MODE.MANUAL ) {
  //   i_scrollMode = false;
  // }

  interface pageData {
    page: number;
    items: any; // Replace YourItemType with the actual type of items
    // Add more properties as needed
  }

  const fetchComponentData = () => {
    setCardListData([])
    setCurrentPageIndex(1);
    setCurrentPageData([]);

    const url = getUrl(props);
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};

    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(parsedData => {
        setData(parsedData);
      })
      .catch(error => {
        console.error("Error fetching data", error);
      });
  }

  const Carouselsettings = {
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: isCircular ? 9 : 4,
    slidesToScroll: props.scrollCount,
    initialSlide: 0,
    dots: isCircular ? false : true,
    arrows: isCircular ? true : false,
    swipeToSlide: true,
    variableWidth: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,


    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: props.scrollCount,
          variableWidth: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: props.scrollCount,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false

        }
      }
    ]
  };

  const getCarousel = () => {
    return <div>
      <Slider {...Carouselsettings} ref={carouselRef}>
        {cardListData && renderCardList()}
      </Slider>
    </div>
  }

  const clearSSR = () => {
    endpoint.SSRDataObj = null;
  }

  const dataAvailable = (pageIndex: number) => {
    let currentDataAvailable = false;
    let currentData = [...cardListData];

    for (var i = 0; i < currentData.length; i++) {
      if (currentData[i].page == pageIndex) {
        return currentData[i].items;
      }
    }
    return currentDataAvailable;
  }

  const handlePaginationChange = (event: any, index: number) => {
    clearSSR();
    let isSelectedPageAvailable = dataAvailable(index);

    if (isSelectedPageAvailable) {
      setCurrentPageData(isSelectedPageAvailable);
    } else {
      getAnotherPageData(index, false);
    }
    setCurrentPageIndex(index);
  }

  const getAnotherPageData = (val: number, isLoadMore: boolean) => {
    let url = getUrl(props, val, isLoadMore);
    
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = {'p-nonce': headerString};

    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(value => {
        if (type1 == "page") {
          let obj: pageData = { page: val, items: value.items };

          setCardListData([...cardListData, obj])
          setCurrentPageData(value.items);
        } else {
          setCardListData([...cardListData, ...value.items])
          type1 == "load" ? setCurrentPageData([...cardListData, ...value.items]) : setCurrentPageData(value.items);
          setCurrentPageIndex(currentPageIndex + 1)
        }
      })
  }

  const handleNextBtnClick = () => {
    clearSSR();
    let dataLength = showAdSlot && (props.adNetwork === "can" || (props.adNetwork === "google" && currentPageIndex === 1)) ? 3 : 4;

    if (cardListData.length >= (dataLength * currentPageIndex) + 1) {
      let currentpagedata = [...cardListData];
      var lastItemLenght = cardListData.length - (dataLength * currentPageIndex);
      if (lastItemLenght > 4) {
        lastItemLenght = showAdSlot && (props.adNetwork === "can" || (props.adNetwork === "google" && currentPageIndex === 1)) ? 3 : 4;
      }
      let updatedArr = currentpagedata.splice((dataLength * currentPageIndex), lastItemLenght);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex + 1)

    } else {
      getAnotherPageData(currentPageIndex + 1, false);
    }
  }

  const handlePrevBtnClick = () => {
    if (currentPageIndex == 1) {
      return;
    } else {
      clearSSR();
      let currentpagedata = [...cardListData];
      let dataLength = showAdSlot && (props.adNetwork === "can" || (props.adNetwork === "google" && currentPageIndex === 1)) ? 3 : 4;
      let updatedArr = currentpagedata.splice(dataLength * (currentPageIndex - 2), dataLength);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex - 1)
    }
  }

  const handleLoadMoreClick = () => {
    clearSSR();
    getAnotherPageData(currentPageIndex + 1, false)
  }

  const renderPagination = () => {
    return <PaginationTwo
      type={type1}
      handlePaginationChange={handlePaginationChange}
      paginationMetaData={paginationMetaData}
      handleNextBtnClick={handleNextBtnClick}
      handlePrevBtnClick={handlePrevBtnClick}
      handleLoadMoreClick={handleLoadMoreClick}
      currentPageIndex={currentPageIndex}
    />
  }

  const renderGridView = () => {
    return <div>
      <div className={`grid-wrapper gridForListingPage manage-grid-pagination${type1 == "load" ? "wrap-list" : ""}`}>
        {currentPageData && currentPageData.length && renderCardList()}
      </div>
      {paginationMetaData.count && renderPagination()}
    </div>
  }

  const handleLoadMoreData = (data: any) => {
    let finalData: any = [];

    for (let i = 0; i < data.length; i++) {
      if (i === 2 || (i - 2) % 3 === 0) {
        finalData.push("", data[i]);
      } else {
        finalData.push(data[i]);
      }
    }
    return finalData;
  }

  const handleCarouselAdSlot = (data: any) => {
    let updatedArr = [];

    for (var i = 0; i < data.length; i++) {
      if (i === 2 || i % 3 === 2) {
        updatedArr.push("");
      }
      updatedArr.push(data[i]);
    }

    return updatedArr;
  }

  const renderCardList = () => {
    if (!Array.isArray(currentPageData)) {
      console.error('currentPageData is not an array or is undefined');
      return [];
    }
    const listData = [];

    let renderData = [...currentPageData];

    if (showAdSlot && props.adNetwork === "google" && currentPageIndex === 1) {
      renderData.splice(2, 0, "");
    } else if (showAdSlot && props.adNetwork === "google" && currentPageIndex > 1 && type1 === "load") {
      renderData.splice(2, 0, "");
    } else if (showAdSlot && props.adNetwork === "can") {
      if (renderData.length >= 3 && !isCarousel && type1 != "load") {
        renderData.splice(2, 0, "")
      }

      if (renderData.length >= 3 && !isCarousel && type1 == "load") {
        renderData = handleLoadMoreData(renderData)
      }

      if (renderData.length && isCarousel) {
        renderData = handleCarouselAdSlot(renderData)
      }
    }

    let bodySnippet: any;
    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      let resolution = `266 X 334`;
      if ((window as any).gpEditor && (window as any).gpEditor.getDevice() === 'Mobile portrait') {
        resolution = `154 X 210`;
      }
      bodySnippet = `<div class="quickview_wrap" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #f0f0f0;"><div class="ad-box" style="width: 266px;height: 334px;display: flex;align-items: center;justify-content: center;">Ad Slot<br>${resolution}</div></div>`
    } 
    else if (isCSR()) {
      console.log("Only CSR");
      // if (clientDevice.isDesktop) {
      //     bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // } else if (clientDevice.isMobile) {
          
      //     bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // }
      bodySnippet = props?.data?.attributes?.adConfigurations;
    }
    else {
        console.log("Only SSR");
        // bodySnippet = `<div></div>`;
        bodySnippet = props?.data?.attributes?.adConfigurations;
    }

    var isViewport = false;
    if (!showViewport) { imagesInViewport = 0; }
    else {
      if (typeof imagesInViewport === 'string' && imagesInViewport.toUpperCase() === "ALL") {
        imagesInViewport = renderData.length;
      } else if (typeof imagesInViewport === 'string' && !isNaN(parseInt(imagesInViewport))) {
        imagesInViewport = parseInt(imagesInViewport);
      } else { imagesInViewport = 0; }
    }



    for (let i = 0; i < renderData.length; i++) {
      if (renderData[i] == "") {
        const Id = "ad-grid-" + currentPageIndex + "_" + i;
        let pageIndex = currentPageIndex + i
        let rerender = true;
        if (type1 === "load") {
          pageIndex = 1 + i;
          rerender = false;
          if (renderData.lastIndexOf("") === i) {
            rerender = true;
          }
        }

        let finalBody: String = "";
        if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
          finalBody = addDataPosition(bodySnippet, pageIndex);
          listData.push(<div className={!isCarousel ? "ThemeTwoGridListCardMainWrap" : "quickview_main_wrap"}><div key={i} id={Id} className="quickview_main_wrap managequickview" dangerouslySetInnerHTML={{ __html: finalBody }}></div></div>)

        } else {
          // finalBody = addDataPosition(bodySnippet, pageIndex);
          listData.push(<div className={!isCarousel ? "ThemeTwoGridListCardMainWrap" : "quickview_main_wrap"}><div key={i} id={Id} className="quickview_main_wrap managequickview">{insertAdSlot(i, bodySnippet, props.name)}</div></div>)
        }

        // const finalBody = addDataPosition(bodySnippet, pageIndex);
        // listData.push(<div className={!isCarousel ? "ThemeTwoGridListCardMainWrap" : "quickview_main_wrap"}><div key={i} id={Id} className="quickview_main_wrap managequickview" dangerouslySetInnerHTML={{ __html: finalBody }}></div></div>)
        //refresh the colombia ad
        if (!isCarousel && !isCircular && showAdSlot && rerender) {
          refreshTheAd(finalBody, refreshAdPg, setRefreshAdPg, currentPageIndex);
        }
      } else {
        if (imagesInViewport > i) { isViewport = true; }
        else { isViewport = false; }
        listData.push(<Card
          item={renderData[i]}
          showDate={showDate}
          mobileView={mobileView}
          showAuthor={showAuthor}
          cardTextColor={cardTextColor}
          key={i}
          isCarousel={isCarousel}
          CONSTANTS={props.CONSTANTS}
          isViewport={isViewport}
          anchorLinksValue={anchorLinksValue}
          
        />)
      }
    }

    return listData;
  }

////console.log('listData',listData)
  return (
    <div className={`card_wrapper ${isCircular ? "circular" : ""}`} onClick={onClick}>
      <CacheProvider value={getMUICache()}>
        <div className="ThemeTwoGridListHeadingWrap">
          <p className="ThemeTwoWGridListHeading themeTwoCommonComponentsHeading"><a href={mainHeadingHref} style={{color:mainHeadingColor}}>{mainHeading}</a></p>
          <span className="">{showViewAll && <a href={viewAllUrl} target={fetchAnchorValue(anchorLinksValue, viewAllUrl)} className="showAll">View All</a>}</span>
        </div>
        <div>
          {isCarousel ? getCarousel() : renderGridView()}
        </div>
      </CacheProvider>
    </div>
  );
}
